<template lang="html">
  <div id="Project">
    <div class="gm-layout-horizontal gm-layout-match-parent">
      <!-- Sidebar -->
      <Sidebar :project.sync="project" :showSidebar="showSidebar" :changeState="changeState"></Sidebar>
      <!-- Sidebar background -->
      <div class="sidebar-background" @click="sendShowSidebarEvent(false)" :style="sidebarBackStyle"></div>
      <div class="gm-layout-match-parent">
        <!-- Menu button -->
        <div class="floating-ui menu gm-shadow">
          <el-button icon="el-icon-s-fold" @click="sendShowSidebarEvent(false)" style="border: none;" v-if="showSidebar"></el-button>
          <el-button icon="el-icon-s-unfold" @click="sendShowSidebarEvent(true)" style="border: none;" v-else></el-button>
        </div>
        <!-- Map -->
        <KakaoMap class="gm-layout-match-parent" :changeState="changeState"></KakaoMap>
      </div>
    </div>
    <!-- Password dialog -->
    <el-dialog title="비밀번호를 입력해주세요 🐈" :visible.sync="showPasswordDialog" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="프로젝트 비밀번호를 입력해주세요">
          <el-input placeholder="비밀번호를 입력해주세요" v-model="userPassword" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="password" @click="checkPassword()">확인</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { db } from '@/firebase'
import KakaoMap from '@/components/Project/KakaoMap'
import Sidebar from '@/components/Project/Sidebar'
export default {
  name: 'Project',
  components: {
    KakaoMap,
    Sidebar
  },
  data: () => ({
    selectedTeamIndex: -1, // -1 = 전체
    uid: null,
    pid: null,
    pidRef: null,
    subscribers: [],
    userPassword: null,
    showPasswordDialog: false,
    showSidebar: true,
    markerStateSubsCallNum: 0,
    project: {
      projectInfo: {},
      mapData: {},
      markerState: []
    },
    sidebarBackStyle: {
      opacity: '0',
      visibility: 'hidden',
      transition: 'opacity .5s ease, visibility 0s ease .5s'
    }
  }),
  mounted() {
    // Initiate
    if (this.$store.state.isMobile) this.showSidebar = false

    // Html & Body no scroll style
    document.getElementById('html').classList.add('height-100')
    document.getElementById('body').classList.add('height-100')

    this.initDB()
    this.checkIsOwner()

    // Subscribe
    this.subscribeProjectInfo()

    // Add event listener
    this.getMarkerSelectedEvent()
  },
  beforeDestroy() {
    // Html & Body no scroll style
    document.getElementById('html').classList.remove('height-100')
    document.getElementById('body').classList.remove('height-100')

    // Unsubscribe
    this.subscribers.forEach(subscriber => {
      subscriber.call()
    })

    // Remove event listener
    this.$event.$off([
      this.$eventList.markerSelected
    ])
  },
  methods: {
    initDB() {
      this.uid = this.$route.params.uid
      this.pid = this.$route.params.pid
      this.pidRef = db.collection('users').doc(this.uid).collection('projects').doc(this.pid)
    },
    checkIsOwner() {
      const user = this.$store.state.user
      this.$log.d('user', user)
      if (user !== null && user !== undefined && ('uid_' + user.id) === this.uid) {
        // Owner
        this.$log.d('owner')
        this.showPasswordDialog = false
        this.subscribeMapData()
        this.$event.$emit(this.$eventList.isProjectOwner, true)
      } else {
        this.$log.d('not owner')
        // Demo pw
        if (this.$route.query.pw !== undefined) {
          this.userPassword = this.$route.query.pw
        }
        this.showPasswordDialog = true
        this.$event.$emit(this.$eventList.isProjectOwner, false)
      }
    },
    getMarkerSelectedEvent() {
      this.$event.$on(this.$eventList.markerSelected, _ => {
        // Mobile인 경우 close sidebar
        if (this.$store.state.isMobile) this.sendShowSidebarEvent(false)
      })
    },
    // Subscribe projectInfo
    subscribeProjectInfo() {
      this.$vs.loading()
      const subscriber = this.pidRef.collection('info').doc('project').onSnapshot(res => {
        this.$log.d('projectInfoSub', res.data())
        if (res.data() === undefined) {
          // 올바르지 않은 접근인 경우 메인으로 보냄
          this.$vs.loading.close()
          this.$router.push('/page_not_found')
          return
        }
        this.$store.commit('setTitle', res.data().name)
        this.project.projectInfo = res.data()

        this.$vs.loading.close()
        this.$event.$emit(this.$eventList.teamsNum, this.project.projectInfo.teamsNum)
      }, error => {
        this.$log.w(error)
        this.$vs.loading.close()
      })

      this.subscribers.push(subscriber)
    },
    // Subscribe mapData
    // 맵 데이터 로드 후 마커 상태 로드
    subscribeMapData() {
      this.$vs.loading()
      const subscriber = this.pidRef.collection('info').doc('markers').onSnapshot(res => {
        this.$log.d('mapDataSub', res.data())
        this.project.mapData = res.data()
        this.$event.$emit(this.$eventList.mapDataLoaded, this.project.mapData)
        // 마커 상태 로드
        this.subscribeMarkerstate()
      }, error => {
        this.$log.w(error)
        this.$vs.loading.close()
      })

      this.subscribers.push(subscriber)
    },
    // Subscribe markerState
    subscribeMarkerstate() {
      this.$vs.loading()
      this.pidRef.collection('state').get().then(docs => {
        // 초기 markerState 데이터 로드
        this.$log.d('load markerState once')

        // markerState에 팀수만큼 배열 생성
        let tempMarkerState = []
        for (let i = 0; i < Number(this.project.projectInfo.teamsNum); i++) {
          tempMarkerState.push([])
        }

        docs.forEach(doc => {
          const m = doc.data()
          tempMarkerState[m.teamIndex].splice(m.markerIndex, 1, m.state)
        })
        /* sidebar에서 project.markerState를 computed 하고 있으므로 해당값이 매번 변하면
         * 성능상 안좋으므로 tempMarkerState에 넣고 한번에 set 해줌
         */
        this.project.markerState = JSON.parse(JSON.stringify(tempMarkerState))

        this.$event.$emit(this.$eventList.markerStateLoaded, this.project.markerState)

        // markerState 변화 구독
        docs.forEach(doc => {
          const subscriber = doc.ref.onSnapshot(res => {
            this.$log.d('markerStateSub', res.data(), this.markerStateSubsCallNum)
            const m = res.data()
            if (this.markerStateSubsCallNum >= this.project.projectInfo.markersNum) {
              this.$log.d('markerState Change')
              this.project.markerState[m.teamIndex].splice(m.markerIndex, 1, m.state)
              this.$event.$emit(this.$eventList.markerStateLoaded, this.project.markerState)
            }
            this.markerStateSubsCallNum++
          })
          this.subscribers.push(subscriber)
        })

        // TODO :: this.$eventList.markerStateLoaded 쏴줘야함
        // this.$event.$emit(this.$eventList.markerStateLoaded, this.project.markerState)
        this.$vs.loading.close()
      })
    },
    sendShowSidebarEvent(isShow) {
      this.showSidebar = isShow
      this.sidebarBackStyle.opacity = (this.showSidebar) ? '1' : '0'
      this.sidebarBackStyle.visibility = (this.showSidebar) ? 'visible' : 'hidden'
      this.sidebarBackStyle.transition = (this.showSidebar) ? 'opacity .5s ease' : 'opacity .5s ease, visibility 0s ease .5s'
      this.$event.$emit(this.$eventList.showSidebar, this.showSidebar)
    },
    checkPassword() {
      this.$log.d('project pw:', this.project.projectInfo.pw)
      if (this.userPassword === this.project.projectInfo.pw) {
        this.$vs.notify({
          title: '환영합니다',
          text: '즐거운 프로젝트 되세요 👏',
          color: 'success',
          position: 'top-center'
        })
        this.showPasswordDialog = false
        this.subscribeMapData()
      } else {
        this.$vs.notify({
          title: '비밀번호가 일치하지 않아요',
          text: '다시 입력해주세요 😭',
          color: 'warning',
          position: 'top-center'
        })
      }
    },
    changeState(teamIndex, markerIndex) {
      const id = `${teamIndex}${markerIndex}`
      this.pidRef.collection('state').doc(id).update({
        state: this.project.markerState[teamIndex][markerIndex]
      })
    }
  },
  computed: {
    progress() {
      const progress = {
        totalProgress: 0, // 전체 진행상황
        progressByTeam: [] // 팀 별 진행상황
      }
      if (this.project.markerState === undefined) {
        return progress
      }
      const totalNum = this.project.projectInfo.markersNum
      var doneNum = 0
      this.project.markerState.forEach((team, teamIndex) => {
        progress.progressByTeam.push({
          doneNum: 0,
          totalNum: Object.keys(team).length,
          isDone: false
        })
        Object.keys(team).forEach(markerIndex => {
          const isDone = team[markerIndex]
          if (isDone) {
            doneNum++
            const teamProgress = progress.progressByTeam[teamIndex]
            teamProgress.doneNum++
            teamProgress.isDone = teamProgress.doneNum === teamProgress.totalNum
          }
        })
      })
      progress.totalProgress = doneNum / totalNum * 100 | 0
      return progress
    }
  }
}

</script>
<style lang="scss" scoped>
#Project {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .floating-ui {
    position: absolute;
    z-index: 1000;

    .el-button {
      width: 38px;
      padding: 0px;
      height: 38px;
    }
  }

  .menu {
    margin: 8px;
    background-color: white;
    padding: 0px;
    border-radius: 8px;
  }

  .sidebar-body {
    padding: 0px;

    .header {
      font-size: 12px;
    }

    .icon {
      font-size: 14px;
      margin-right: 2px;
    }

    .title {
      box-shadow: 0 7px 7px -5px rgba(0, 0, 0, .08);
      padding: 12px 0px 12px 4px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }
  }

  .footer-sidebar {
    display: flex;
    align-items: center;
    height: 35px;

    >button {
      border: 0px solid rgba(0, 0, 0, 0) !important;
      border-left: 1px solid rgba(0, 0, 0, .07) !important;
      border-radius: 0px !important;
      height: 100%;
      width: 45px;
      padding: 4px;
    }
  }
}

</style>
<style lang="scss">
#Project {
  .vs-list {
    padding: 4px 0px 4px 4px;
  }

  .vs-sidebar--items {
    padding: 0px !important;
  }

  .vs-collapse-item--header {
    padding: 0px 0px 4px 0px;
  }

  .con-content--item {
    padding: 0px 2px 0px 0px;
  }

  .marker {
    padding: 4px;
  }

  .marker-title {
    font-weight: 550;
    font-size: 14px;
    margin-bottom: 4px;
  }

  .marker-address {
    font-size: 10px;
    margin-bottom: 4px;
  }

  .marker-phone {
    font-size: 12px;
  }
}

.el-dialog {
  width: 280px !important;
}

.el-dialog__header {
  margin-top: 50%;
  padding: 8px 8px 0px 8px;
}

.el-input__inner {
  height: 35px;
}

.el-dialog__body {
  padding: 4px 16px;
}

.el-dialog__footer {
  padding: 4px 16px 8px 16px;
}

/* Mobile */
@media only screen and (max-width : 768px) {

  .sidebar-background {
    position: fixed;
    -webkit-filter: blur(1px);
    filter: blur(1px);
    z-index: 2001;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.8);
    transition: opacity .5s ease;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Project/index.vue